import React, { useState } from 'react';
import { Form, Input, Select, Button, Row, Col, notification, Skeleton } from 'antd';
import { projectStacks } from '../../services/cs-lab-config';
import { generateAiQuestion } from '../../services/ide-apis';
import { getIdeProjectTypeMetaData } from '../utils/util-functions';
import { ReactComponent as AiIconWhite } from '../../assets/logos/ai icon white.svg';
import { ReactComponent as QuestionMark } from '../../assets/logos/question mark.svg';
import ClassRoomMasterLoader from '../common/classroom-master-loader';
import { trackEvent } from "../utils/util-functions";

const AiQuestions = ({ 
  handleAiQuestionData,
  selectedProject,
  grade,
  topic,
  additionalInfo,
  setSelectedProject,
  setGrade,
  setTopic,
  setAdditionalInfo
 }) => {

    const { Option } = Select;
    const [isLoading, setIsLoading] = useState(false);
    const [aiForm] = Form.useForm();

    const fnGenerateAiQuesion = async () => {
        try {

            if (!selectedProject) {
                return notification.error({
                    message: 'Error',
                    description: 'Please select a project type',
                });

            }

            if (!grade) {
                return notification.error({
                    message: 'Error',
                    description: 'Please select a grade',
                });
            }

            if (!topic) {
                return notification.error({
                    message: 'Error',
                    description: 'Please select topic',
                });
            }

            const reqObj = {
                "subject": selectedProject,
                "grade": grade,
                "topic": topic
            };

            if (additionalInfo) {
                reqObj.additionalInstruction = additionalInfo;
            }

            setIsLoading(true);

            trackEvent('generate_ai_question_button_clicked', {
                from: 'csLab',
                ide_project_stack_name: selectedProject,
                grade,
                topic
            });

            const response = await generateAiQuestion(reqObj);
            setIsLoading(false)
            if (response.data.statusCode === 200) {
                notification.success({
                    message: 'Success',
                    description: 'AI question generated successfully.',
                });
                if (response.data.response.questionTitle && response.data.response.question) {
                    if (response.data.response.example) {
                        response.data.response.question = response.data.response.question +  "<br>" + response.data.response.example;
                    }
                    
                    const questionObj = { questionTitle: response.data.response.questionTitle, question: response.data.response.question, aiProjectType: selectedProject }
                    handleAiQuestionData(questionObj)
                }
            }

        } catch (error) {
            notification.error({
                message: 'Error',
                description: error.message,
            });
            setIsLoading(false)
        }
    };

    const handleProjectTypeChange = (value) => {
        setSelectedProject(value);
    };

    const handleClassChange = (value, classObj) => {
        setGrade(classObj.className);
    };

    const handleTopicChange = (e) => {
        setTopic(e.target.value);
    };

    const handleAdditionalInfoChange = (e) => {
        setAdditionalInfo(e.target.value);
    };

    return (
        <>

            <Form layout="vertical" form={aiForm} >
                <Row >
                    <Form.Item className='poppins-regular mr-2'
                        labelCol={{ className: 'poppins-regular' }}
                        label="Project Type"
                    >

                        <Select value={selectedProject} onChange={handleProjectTypeChange}>
                            <Option value="default" disabled>
                                Select a project type
                            </Option>
                            {Object.values(projectStacks)
                                .flatMap((items) =>
                                    items
                                        .map((item) => ({
                                            ...item,
                                            metaData: getIdeProjectTypeMetaData(item.projectStackName),
                                        }))
                                        .filter((item) => item.metaData.showLabQuestion)
                                )
                                .map((item) => (
                                    <Option key={item.projectStackName} value={item.projectStackName}>
                                        {item.metaData.projectStackDisplayName}
                                    </Option>
                                ))}
                        </Select>
                    </Form.Item>

                    <Form.Item className='poppins-regular mr-2'
                        labelCol={{ className: 'poppins-regular' }}
                        label="Grade"
                    >
                        {/* <InputNumber placeholder='Enter grade' style={{ width: '150px' }} onChange={handleGradeChange} /> */}
                        <ClassRoomMasterLoader
              classId={grade}
              onChange={handleClassChange}
              showAllOption={false}
              selectMultiple={false}
              loadAllClassRoom={true}
             
            />
                    </Form.Item>

                    <Form.Item className='poppins-regular mr-2'
                        labelCol={{ className: 'poppins-regular' }}
                        label="Topic"
                    >
                        <span>
                        <Input value={topic} className='mr-2' t placeholder='Enter Topic' style={{ width: '175px' }} onChange={handleTopicChange} />
                        <QuestionMark/>
                        </span>
                        
                    </Form.Item>

                    
                    


                </Row>


                <Form.Item className='poppins-regular'
                    labelCol={{ className: 'poppins-regular' }}
                    label="Instructions( optional )"
                >
                    <Input.TextArea value={additionalInfo} rows={3} placeholder='Type your instructions to AI here' onChange={handleAdditionalInfoChange} style={{ width: '65%' }} />

                </Form.Item>
            </Form>





            <Row justify="start">
            <Col span={7}> {/* Adjust the span if needed */}
                {isLoading ? (
                    <Skeleton.Button active={true} size="large" block={true} />
                ) : (
                    <Button type="primary" onClick={fnGenerateAiQuesion} size="large">
                        Generate
                        <AiIconWhite />
                    </Button>
                )}
            </Col>
        </Row>
            
        <hr/>
      </>
    )
}

export default AiQuestions;
